import { hofAddHomeScreen } from './lib/hofAddHomeScreen';
import searchParams from './lib/searchQuery';

import Game from './components/Game';
import HofCanvas from './components/canvas';
import Dom from './components/dom';
import gtmInit, { GtmEvens } from './components/gtm';
import JqueryCode from './components/jquery-code';
import HofUser from './components/user';
import hofCookie, { QS_PARAMS } from './lib/cookie-data';
import ready from 'document-ready';
import storage from './lib/local-storage';
import gtmDataLayerPush from './lib/gtmDataLayerPush';

// Strip bare '#' that can land in the URL when an href="#" button is clicked
// before JS event listeners are attached.
if (location.hash === '#') {
	history.replaceState(null, '', location.pathname + location.search);
}

ready(async () => {
	const hasSearch = searchParams.size > 0;

	if (hasSearch) {
		hofCookie.set(QS_PARAMS, searchParams.toString());
	}

	const hofUser = new HofUser();

	await hofUser.init();

	window.hofUser = hofUser;

	gtmInit();

	if (storage.has(GtmEvens.FUNNEL_FINISH)) {
		const payload = storage.get(GtmEvens.FUNNEL_FINISH);
		gtmDataLayerPush(GtmEvens.FUNNEL_FINISH, payload);
		storage.remove(GtmEvens.FUNNEL_FINISH);
	}

	new HofCanvas(hofUser);
	new Dom();

	const game = new Game(hofUser);

	game.init();

	hofAddHomeScreen();

	(($) => new JqueryCode($))(jQuery);
});
